module.exports = __webpack_public_path__ + "img/smile.e53f9c51.svg";